import { queryOptions } from "@tanstack/react-query";
import { getWhitelist, listApiKeys } from "./api";

export const apiKeyKeys = {
  all: ["api-keys"] as const,
  list: () => [...apiKeyKeys.all, "list"] as const,
  whitelist: (keyId: string) => [...apiKeyKeys.all, "whitelist", keyId] as const,
};

/** Every key the reseller issued, newest first: never the key itself, which only issue and rotate return. */
export const apiKeysQuery = () =>
  queryOptions({ queryKey: apiKeyKeys.list(), queryFn: async () => (await listApiKeys()).data });

export const whitelistQuery = (keyId: string) =>
  queryOptions({
    queryKey: apiKeyKeys.whitelist(keyId),
    queryFn: async () => (await getWhitelist(keyId)).data.entries,
  });
